import { isEmpty } from "ramda";
import React, { useEffect, useState } from "react";
import { Calendar, DateObject } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";

import {
  apiCallComplete,
  isMarkOffHolidayPending,
  isApiPending,
} from "../../../dux/apiStatus";
import { markDaysOffHoliday } from "../../../dux/markDaysOffHoliday";
import {
  updateSpecialSchedule,
  fetchSpecialScheduleDates,
  fetchHolidayDates,
} from "../../../dux/bookNow";
import Loader from "../../shared/UI/Loader/Loader";
import LoaderForButton from "../../shared/UI/LoaderForButton";
import styles from "./Calendar.module.css";

const format = "YYYY/MM/DD";

// const typeToText = { 1: "holiday", 2: "off" };

// Map frontend sport names to backend sport names
const sportMapping = {
  Football: "football",
  "Box Cricket": "box-cricket",
  "Cricket Net": "cricket-net",
  "Pickle Ball": "pickle-ball",
};

// Remove getAllowedLocations and any local location assignment
// Only use the location prop

export default function App({ type, sport, location }) {
  const [dates, setDates] = useState([]);
  const dispatch = useDispatch();
  const markOffHolidayPending = useSelector(isMarkOffHolidayPending);
  const updateSpecialSchedulePending = useSelector((state) =>
    isApiPending(state, "updateSpecialSchedule")
  );
  const fetchingSpecialScheduleDates = useSelector((state) =>
    isApiPending(state, "fetchSpecialScheduleDates")
  );
  const fetchingHolidayDates = useSelector((state) =>
    isApiPending(state, "fetchHolidayDates")
  );

  useEffect(() => {
    if (!location) return;

    if (type === 1) {
      // For "Mark Holidays" - fetch special schedule dates
      dispatch(
        fetchSpecialScheduleDates({
          sport: sportMapping[sport] || sport,
          location: location,
        })
      );
    } else {
      // For "Mark Off Days" - fetch holiday dates using new API
      dispatch(
        fetchHolidayDates({
          sport: sportMapping[sport] || sport,
          location: location,
        })
      );
    }

    return () => {
      if (type === 1) {
        dispatch(apiCallComplete({ api: "fetchSpecialScheduleDates" }));
      } else {
        dispatch(apiCallComplete({ api: "fetchHolidayDates" }));
      }
    };
  }, [sport, dispatch, location, type]);

  useEffect(() => {
    setDates([]);
  }, [type, type === 1 ? fetchingSpecialScheduleDates : fetchingHolidayDates]);

  const submitHandler = () => {
    if (!location) return;

    if (type === 1) {
      // For "Mark Holidays" - use special schedule API
      dispatch(
        updateSpecialSchedule({
          sport: sportMapping[sport] || sport,
          location: location,
          dates: dates.map((date) => date.format("DD/MM/YYYY")),
        })
      );
    } else {
      // For "Mark Off Days" - use holiday API
      dispatch(
        markDaysOffHoliday({
          dateArr: dates.map((date) => date.format("DD/MM/YYYY")),
          type,
          sport: sportMapping[sport] || sport,
          location,
        })
      );
    }
  };

  return (
    <div className={styles.container}>
      {(type === 1 ? fetchingSpecialScheduleDates : fetchingHolidayDates) ? (
        <Loader />
      ) : (
        <>
          <Calendar
            minDate={new Date()}
            maxDate={new DateObject().add(60, "day")}
            format={format}
            value={dates}
            onChange={setDates}
          ></Calendar>

          <span className={styles.dateTitle}>Selected By You</span>
          <div className={styles.datesContainer}>
            {dates.length === 0 && "No dates are selected yet."}
            {dates.sort().map((date) => (
              <span key={date} className={styles.dateCard}>
                {date.format("DD/MM/YYYY")}
              </span>
            ))}
          </div>
          <button
            className={styles.btn}
            onClick={submitHandler}
            disabled={
              isEmpty(dates) ||
              markOffHolidayPending ||
              updateSpecialSchedulePending
            }
          >
            {markOffHolidayPending || updateSpecialSchedulePending ? (
              <LoaderForButton />
            ) : (
              "PROCEED"
            )}
          </button>
        </>
      )}
    </div>
  );
}
